export enum ProductScopeEnum {
  CARD = 'card',
  COMPARATOR = 'comparator',
  CATEGORIES = 'categories',
  FAQ = 'faq',
  IFU = 'ifu',
  ACCESSORY = 'accessoryHome',
  ACCESSORIES = 'accessories',
  PRICE = 'price',
  STOCK = 'stock',
  PRICE_AND_STOCK = 'priceAndStock'
}
